import React, { useEffect, useState } from 'react';
import BookImg from '../../Images/img.png'
import '../../Styles/ConfirmLesson.css'
import { MAIN_URL } from '../../constants';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../RefreshToken/RefreshToken';

const ConfirmLesson = () => {

    const [courses, setCourses] = useState([]);
    const navigate = useNavigate()
    const TOKEN = localStorage.getItem("admin_token")
    useEffect(() => {
        const getMyCourses = () => {

            api.get(`/management/mentor/my-courses?confirmed=false`, {
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${TOKEN}`, 
                },
            })
                .then((response) => {
                    setCourses(response.data);
                })
                .catch((error) => {
                });
        };

        getMyCourses();
    }, []);


    const handleSelectCourse = (course) => {
        navigate('/course-details', { state: { course } });

    };

    return (
        <div className='confirm-lesson'>
            <h4 className="confirm-lesson-title">Confirmation of lessons</h4>
            {courses.length === 0 ? (
                <div>There are no courses to be approved</div>
            ) : (
                courses?.map((course, index) => (
                    <div key={index} onClick={() => handleSelectCourse(course)} className='confirmation-container'>
                        <span>{index + 1}</span>
                        <div className="confirm-lesson-card1">
                            <img src={`${MAIN_URL}/${course?.photo}`} alt="" className="book-img" />
                            <div className="con-lesson-right">
                                <div className="con-lesson-block">
                                    <h3 className="con-block-title">{course?.title}</h3>
                                    <p className="con-desc" dangerouslySetInnerHTML={{ __html: course?.description }}></p>
                                </div>
                            </div>
                        </div>
                    </div>
                ))
                
            )} 
        </div>
    );
}

export default ConfirmLesson;
